export const name = "TANH";
export const summary = `Computes the hyperbolic tangent of \`X\`.`;
export const reference = `
## TANH

Computes the hyperbolic tangent of \`X\`.

\`\`\`
TANH(X)
\`\`\`

### Description

Computes the hyperbolic tangent of X where X is specified in radians. Doesn't fail.

| X | TANH(X) |
| --- | --- |
| \`+inf\` | 1.0 |
| \`-inf\` | -1.0 |
| \`NaN\` | \`NaN\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
